import * as React from 'react'

const Icon3DotVer = (props) => {
  const { color } = props
  return (
    <svg
      width={24}
      height={24}
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M14 12a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 12m0 7a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 19m0-14a2 2 0 1 1-4.001-.001A2 2 0 0 1 14 5'
        fill={color || '#FFF'}
        fillRule='evenodd'
      />
    </svg>
  )
}

export default Icon3DotVer
